import { axiosWithAuth } from "helpers";

export const pendoService = {
	getUserProfile,
};

const API_URL = process.env.REACT_APP_API_URL;

function getUserProfile() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/me/pendo/metadata`,
	};

	return axiosWithAuth(options);
}
